import { render, staticRenderFns } from "./order_items__detail_report.vue?vue&type=template&id=36210729&scoped=true&"
import script from "./order_items__detail_report.vue?vue&type=script&lang=js&"
export * from "./order_items__detail_report.vue?vue&type=script&lang=js&"
import style0 from "./order_items__detail_report.vue?vue&type=style&index=0&id=36210729&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36210729",
  null
  
)

export default component.exports